import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider,Tabs, Tab,  Grid, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import {getListAPI} from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import CommentMgmt from "./comment/CommentMgmt";


export default function TaskSpaceProdGranulation() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const [tabIndex, setTabIndex] = useState(0);
 
  useEffect(() => {
     dispatch(setCompleteTaskButtonEnabled(false));
  },[]);


  const handleRadioChange = (e) => {
    const value = e.target.value
    setConfirmed(value);
    dispatch(setCompleteTaskButtonEnabled(value));
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
          <Grid container sx={{ width: '100%' }}>
            <Grid item lg={4} md={4} sm={4} xs={12}>
              <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
                  <Tabs
                    value={tabIndex}
                    onChange={(_, v) => setTabIndex(v)}
                    variant="fullWidth"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                  >
                    <Tab label="Product Info" />
                    <Tab label="Comments" />
                  </Tabs>
                  <Box sx={{}}>
                    {tabIndex === 0 && (
                      <ProductInfo maxHeight="70vh" />
                    )}
                    {tabIndex === 1 && (
                      <Box sx={{ p: 2, minHeight: '70vh' }}>
                        <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                          <CommentMgmt maxHeight="60vh" status={1} />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
            </Grid>
            <Grid item lg={8} md={8} sm={8} xs={12} sx={{ pt: 2,  }} >
              <Box sx={{ width: '100%',backgroundColor:'white', borderRadius: 2, p: 2 }}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  I confirm that Granulation is Complete and Product is ready for Packaging
                </FormLabel>
                <RadioGroup
                  row
                  value={confirmed}
                  onChange={handleRadioChange} // Call directly, not as arrow function
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio disabled={taskApiResponse && taskApiResponse.status} />}
                    label="Yes"
                    disabled={taskCompleted}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio disabled={taskApiResponse && taskApiResponse.status} />}
                    label="No"
                    disabled={taskCompleted}
                  />
                </RadioGroup>
              </FormControl>
              </Box>
            </Grid>
          </Grid>
      </Grid>
          
    
  );
}